import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import TrendingSection from './TrendingSection';
import { TOP_TOPICS_N } from '../../lib/howItWorksHierarchy';

// The "Top Topics" row for one How Does It Work? section/subsection scope, plus (when
// the scope has more topics than fit) a "More Topics" link right after the card grid,
// right-aligned. Both the landing page (one per category) and the section/subsection
// page (one for the current scope) render this same block so spacing and placement stay
// identical everywhere, including scopes added in the future, without per-caller tweaks.
const TopTopicsBlock = ({
  sectionType,
  items,
  hasMore,
  moreTopicsPath,
  testId,
  size,
  topN = TOP_TOPICS_N,
  title = 'Top Topics',
  moreLabel = 'More Topics',
}) => (
  <div>
    <TrendingSection
      sectionType={sectionType}
      items={items}
      topN={topN}
      fallbackWhenEmpty
      inline
      inlineTitle={title}
      testId={testId}
    />
    {hasMore && (
      <div className="flex justify-end mt-4">
        <Button
          asChild
          variant="outline"
          size={size}
          data-testid={testId ? `more-topics-link-${testId}` : 'more-topics-button'}
        >
          <Link to={moreTopicsPath}>
            {moreLabel}
            <ChevronRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    )}
  </div>
);

export default TopTopicsBlock;
